<div [attr.class]="'chart-pie chart-pie--' + size">
    <canvas #chart></canvas>

    <div class="chart-pie__value" *ngIf="displayValue" [ngStyle]="{'color': valueColor}">
        {{ value | number: '1.0-0' | empty }} {{ dataType }}
    </div>
</div>
